<template>
  <div>
    <side-menu/>
    <loading-screen v-if="loadingScreen"/>
    <new-password-modal v-if="showPasswordModal" @close="showPasswordModal = false"/>
    <register-kit-modal v-if="showKitModal === true" @close="showKitModal = false"/>
    <register-profile-modal v-if="showProfileModal === true" @close="showProfileModal = false"/>
    <section class="container profile-container">
      <div class="profile">
        <h1>Perfil</h1>
        <div class="profile-card">
          <div class="card-body">
            <div class="box">
              <h2>Dados Pessoais</h2>
              <form @submit="handleSubmit">
                <input
                  id="photo"
                  accept=".png, .jpg, .jpeg, .gif"
                  name="photo"
                  style="display: none;"
                  type="file"
                  @change="handleChangePhoto()"/>
                <div class="input-box">
                  <label for="cpf">CPF</label>
                  <input
                    id="cpf"
                    v-model="form.cpf"
                    v-mask="'###.###.###-##'"
                    placeholder="000.000.000-00"
                    :tokens="numberToken"
                    name="cpf"
                    type="text"/>
                  <small v-if="errors && errors.cpf" class="error">{{ errors.cpf.join() }}</small>
                </div>
                <div class="input-box">
                  <label for="name">Nome Completo</label>
                  <input
                    id="name"
                    v-model="form.name"
                    name="name"
                    type="text"/>
                  <small v-if="errors && errors.name" class="error">{{ errors.name.join() }}</small>
                </div>
                <div class="input-box">
                  <label for="gender">Sexo biológico</label>
                  <select
                    id="gender"
                    v-model="form.gender"
                    name="gender">
                    <option value=null>Selecione uma opção</option>
                    <option value="M">Masculino</option>
                    <option value="F">Feminino</option>
                  </select>
                  <small v-if="errors && errors.gender" class="error">{{ errors.gender.join() }}</small>
                </div>
                <div class="input-box">
                  <label for="ethnicity">Etnia</label><select
                  id="ethnicity"
                  v-model="form.ethnicity"
                  name="ethnicity">
                  <option value=null>Selecione uma opção</option>
                  <option value="A">Amarelo</option>
                  <option value="B">Branco</option>
                  <option value="I">Indígena</option>
                  <option value="M">Mestiço</option>
                  <option value="N">Negro</option>
                  <option value="P">Pardo</option>
                </select>
                  <small v-if="errors && errors.ethnicity" class="error">{{ errors.ethnicity.join() }}</small>
                </div>
                <div class="input-box">
                  <label class="datepicker-label" for="birthdate">Data de nascimento</label>
                  <input
                    id="birthdate"
                    v-model="form.birth_date"
                    v-mask="'##/##/####'"
                    placeholder="00/00/0000"
                    :tokens="numberToken"
                    name="birthdate"
                    type="text"/>
                  <small v-if="errors && errors.birth_date" class="error">{{ errors.birth_date.join() }}</small>
                </div>
              </form>
            </div>
            <div class="box">
              <h2>Dados de Contato</h2>
              <form style="margin-bottom: .25rem;" @submit="handleSubmit">
                <div class="input-box">
                  <label for="email">E-mail</label>
                  <input
                    id="email"
                    v-model="form.email"
                    name="email"
                    type="text"/>
                  <small v-if="errors && errors.email" class="error">{{ errors.email.join() }}</small>
                </div>
                <div class="input-box">
                  <label for="cellphone">Celular</label>
                  <input
                    id="cellphone"
                    v-model="form.cellphone"
                    v-mask="'(##) #####-####'"
                    placeholder="(00) 00000-0000"
                    :tokens="numberToken"
                    name="cellphone"
                    type="text"/>
                  <small v-if="errors && errors.cellphone" class="error">{{ errors.cellphone.join() }}</small>
                </div>
              </form>
            </div>
          </div>
          <div class="card-footer profile">
            <div v-if="!loading && !errors && this.form.first_acess && this.showSavedMessage" class="saved">
              <span>Informações salvas com sucesso.</span>
            </div>
            <div class="actions">
              <button v-if="!loading" class="button btn-primary aff" @click="handleSubmit">Salvar Informações</button>
              <button v-if="loading" class="button btn-purple aff" disabled>
                <loading/>
              </button>
              <button v-if="!loading" class="button btn-secondary" v-on:click.stop.prevent="showPasswordModal = true">
                Nova senha
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {GET_CUSTOMER, POST_CUSTOMER} from "../../services/customer";
import NewPasswordModal from "../../components/NewPasswordModal/NewPasswordModal";
import RegisterKitModal from "../../components/ProfileSaveModal/RegisterKitModal";
import RegisterProfileModal from "../../components/ProfileIncompleteModal/RegisterProfileModal";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

import {library} from "@fortawesome/fontawesome-svg-core"
import {faAddressBook, faCalendarAlt, faCamera, faCog, faShoppingCart} from "@fortawesome/free-solid-svg-icons"
import moment from "moment";

library.add(faShoppingCart);
library.add(faCog);
library.add(faCalendarAlt);
library.add(faAddressBook);
library.add(faCamera);

export default {
  components: {DatePicker, NewPasswordModal, RegisterKitModal, RegisterProfileModal},
  data() {
    return {
      errors: {},
      errorPhoto: null,
      loading: false,
      loadingScreen: false,
      showPassword: false,
      showConfirmPassword: false,
      showPasswordModal: false,
      showKitModal: false,
      showProfileModal: false,
      showSavedMessage: false,
      form: {
        name: "",
        email: "",
        birth_date: "",
        cpf: "",
        gender: null,
        ethnicity: null,
        cellphone: "",
        cep: "",
        uf: "",
        city: "",
        street: "",
        number: "",
        district: "",
        status: "",
        password: "",
        password_confirmation: "",
        first_acess: 0,
        profile_picture: null,
      },
      originalForm: null,
      numberToken: {N: {pattern: /[0-9]/}}
    }
  },
  methods: {
    clean(obj) {
      for (const propName in obj) {
        if (!obj[propName]) {
          delete obj[propName];
        }
      }
      return obj
    },
    clearErrors() {
      this.errors = null;
      this.errorPhoto = null;
    },
    async getUserData() {
      try {
        this.loadingScreen = true;
        const response = await GET_CUSTOMER();

        if (!!response) {
          if (!!response.customer) {
            this.form = response.customer;
            this.form.email = response.email;
            this.form.phone1 = response.customer.cellphone;
            this.form.birth_date = moment(response.customer.birth_date, "YYYY-MM-DD").format("DD/MM/YYYY");
            this.form.first_acess = 1;
            this.$store.commit("setUser", response.customer)
          }

          if (!this.form.name && !!response.name) {
            this.form.name = response.name;
          }

          if (!this.form.email && !!response.email) {
            this.form.email = response.email;
          }

          if (!!this.form && this.form.first_acess === 0) {
            this.showProfileModal = true;
          }
        }

        this.originalForm = JSON.stringify(this.form);
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingScreen = false;
        this.form.profile_picture = null;
      }
    },
    infoChanged() {
      return JSON.stringify(this.form) !== this.originalForm;
    },
    handleShowPassword(field) {
      if (field === 0) this.showPassword = !this.showPassword;
      else this.showConfirmPassword = !this.showConfirmPassword;

      const password = field === 0
        ? document.getElementById("password")
        : document.getElementById("confirm_password");

      if (field === 0) {
        password.type = "password";
        if (this.showPassword) password.type = "text";
      }
      if (field === 1) {
        password.type = "password";
        if (this.showConfirmPassword) password.type = "text";
      }
    },
    handleSubmit(event) {
      event.preventDefault();
      this.clearErrors();
      this.loading = true;
      const form = this.form;
      let keepDate = form.birth_date;

      if (!!form.birth_date) {
        let tmp = moment(form.birth_date, "DD/MM/YYYY");
        const oldest = moment("02/01/1903", "DD/MM/YYYY");
        const now = moment();

        if (tmp.isValid() && tmp.isAfter(oldest) && tmp.isBefore(now)) {
          form.birth_date = tmp.format("YYYY-MM-DD");
        } else {
          this.errors = {"birth_date": ["Data de nascimento inválida"]};
          this.loading = false;
          return;
        }
      }

      if (!!form.cpf) {
        form.cpf = form.cpf.replace(/[^0-9]/g, "");
      }

      POST_CUSTOMER((form)).then(r => {
        if (this.form.first_acess === 0) {
          this.showKitModal = true;
        }
        this.showSavedMessage = true;
        this.loading = false;
        this.errors = null;
        this.getUserData();
      }, err => {
        form.birth_date = keepDate;
        this.errors = err.response.data;
        this.loading = false;
      });
    },
  },
  mounted() {
    this.getUserData();
  }
}
</script>

<style scoped>
@import "./profile.scss";
@import "./responsive.css";
</style>



// WEBPACK FOOTER //
// src/views/Profile/Profile.vue